import { Component, AfterViewInit, ElementRef, OnInit, ViewChild } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { InputTextModule } from 'primeng/inputtext';

@Component({
  selector: 'app-limits',
  standalone: true,
  imports: [InputTextModule, TranslateModule],
  templateUrl: './limits.component.html',
  styleUrl: './limits.component.css'
})

export class LimitsComponent implements AfterViewInit {
  @ViewChild('searchInput') searchInput!: ElementRef;
  ngOnit(){

  }
  ngAfterViewInit() {
    this.searchInput.nativeElement.focus();
  }
}
